import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type { BaseProfitItemsVars, UseBulkEditProfitItemsData } from './types';

export type PricingItemsUpdate = 'actual' | 'increase' | 'decrease';

export type UseBulkUpdateProfitItemsData = UseBulkEditProfitItemsData;

export type UseBulkUpdateProfitItemsVars = BaseProfitItemsVars & {
  updateType: PricingItemsUpdate;
  applyOverrides: boolean;
};

export const useBulkUpdateProfitItems: MutationFunction<
  UseBulkUpdateProfitItemsData,
  UseBulkUpdateProfitItemsVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/bulk_update_profit_items`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      }) as Promise<UseBulkUpdateProfitItemsData>,
    queryOptions,
  );
};
